export default __webpack_public_path__ + "assets/favicons/site.webmanifest";